import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Estudiante } from '../../models/estudiante.model';
import { SharedService } from '../../services/shared.service';
import { Graduacion } from '../../models/graduacion.model';

@Component({
  selector: 'app-estudiante-card',
  templateUrl: './estudiante-card.component.html',
  styleUrls: ['./estudiante-card.component.css']
})
export class EstudianteCardComponent implements OnInit {
  @Input() estudiante!: Estudiante;
  @Output() viewDetail = new EventEmitter<Estudiante>();

  graduaciones: Graduacion[] = [];
  graduacionActual: Graduacion | null = null;
  isLoadingGraduacion = true;

  constructor(private sharedService: SharedService) {}

  ngOnInit(): void {
    this.normalizeDatesForDisplay();
    this.loadGraduacion();
  }

  private normalizeDatesForDisplay(): void {
    if (this.estudiante) {
      if (this.estudiante.fcNacimiento) {
        this.estudiante.fcNacimiento = this.sharedService.normalizeDate(this.estudiante.fcNacimiento);
      }
      if (this.estudiante.fcInicio) {
        this.estudiante.fcInicio = this.sharedService.normalizeDate(this.estudiante.fcInicio);
      }
      if (this.estudiante.fcUltimoExamen) {
        this.estudiante.fcUltimoExamen = this.sharedService.normalizeDate(this.estudiante.fcUltimoExamen);
      }
    }
  }

  private loadGraduacion(): void {
    this.sharedService.graduaciones$.subscribe(
      (graduaciones) => {
        this.graduaciones = graduaciones;
        
        // Use idGraduacionActual from estudiante or from graduacionActual relation
        const gradId = this.estudiante.graduacionActual?.id || this.estudiante.idGraduacionActual;
        if (gradId) {
          this.graduacionActual = this.graduaciones.find(g => g.id === gradId) || null;
        }
        
        this.isLoadingGraduacion = false;
      },
      (error) => {
        console.error('Error loading graduaciones:', error);
        this.isLoadingGraduacion = false;
      }
    );
  }

  getGraduacionDescripcion(): string {
    if (this.isLoadingGraduacion) {
      return 'Cargando...';
    }
    
    return this.graduacionActual?.nombre || 'BLANCO/SIN EXAMENES';
  }

  // Use fcUltimoExamen from estudiante object (provided by backend)
  get ultimoExamenFormatted(): string {
    if (!this.estudiante.fcUltimoExamen) {
      return 'Sin exámenes';
    }
    
    const date = new Date(this.estudiante.fcUltimoExamen);
    return date.toLocaleDateString('es-AR');
  }

  get instructorNombre(): string {
    if (this.estudiante.instructor) {
      return `${this.estudiante.instructor.apellido}, ${this.estudiante.instructor.nombre}`;
    }
    return '';
  }

  get centroNombre(): string {
    return this.estudiante.centroEntrenamiento?.nombre || '';
  }

  isValidDate(date: any): boolean {
    if (!date) return false;
    
    try {
      const d = new Date(date);
      return !isNaN(d.getTime());
    } catch (e) {
      return false;
    }
  }

  onViewDetail(): void {
    this.viewDetail.emit(this.estudiante);
  }
}